import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconFolderFile = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M12.414 4H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3v-2h2V6h-8.414l-2-2H4v14h2v2H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h7.414z"
    />
    <path
      fill="currentColor"
      d="M11.925 12H9v8h6v-5h-3.075zm-4.918-1.405c0-.329.248-.595.555-.595h6.667l2.778 3v8.395c0 .334-.247.605-.552.605H7.559c-.305 0-.552-.273-.552-.595z"
    />
  </NcIcon>
);
export { NcIconFolderFile };
